import {
  ConcreteShortName,
  ConcretePlacementDate,
  ConcretePlacementId,
  ConcreteFieldNumber,
  ConcreteTestSubId,
  ConcreteFieldNumbers,
  ConcreteTestSubIds,
  ConcretePlacementIds,
} from '../../filenameTemplateItems/instances/concrete'
import {
  concretes,
  projects,
} from '../../filenameTemplateItems/instances/groups'
import { SimpleReportItem } from '../classes/SimpleReportItem'
import {
  ConcreteTestSetPacketReportItem,
  ConcreteTestSetReportItem,
} from '../classes/concrete'

export const ConcretePlacementCoreSheet = new SimpleReportItem({
  id: '3CEA284E-D128-4D27-8D26-2627F6D4416A',
  name: 'Concrete Placement and Core Sheet',
  classType: 'ConcretePlacement',
  classTypeName: 'Concrete Placement',
  endpoint: 'concretePlacements',
  queryParameter: 'placement-core-sheet',
  label: 'placementId',
  sampleFilename: 'concrete-placement-and-core-sheet',
  afterClientProjectNumber: [
    { type: 'templateItem', templateItemId: ConcreteShortName.id },
    { type: 'custom', text: '_THICKNESS_' },
    { type: 'templateItem', templateItemId: ConcretePlacementDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: ConcretePlacementId.id },
  ],
  compatibleTemplateItems: [ConcretePlacementId, ...projects, ...concretes],
  key: 'globalId',
})

export const ConcreteCylinderIASheet = new SimpleReportItem({
  id: '7E4A502F-3AA6-46D0-8435-24465FF61964',
  name: 'Concrete Cylinder and IA Sheet',
  classType: 'ConcreteTest',
  classTypeName: 'Concrete Test',
  endpoint: 'concreteTests',
  queryParameter: 'cylinder-ia-sheet',
  label: 'fieldNumber',
  sampleFilename: 'concrete-cylinder-and-ia-sheet',
  afterClientProjectNumber: [
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: ConcreteShortName.id },
    { type: 'custom', text: '_CONCRETE-STRENGTH-RPT_' },
    { type: 'templateItem', templateItemId: ConcretePlacementDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: ConcreteFieldNumber.id },
  ],
  compatibleTemplateItems: [
    ConcreteFieldNumber,
    ConcreteTestSubId,
    ...projects,
    ...concretes,
  ],
  key: 'globalId',
})

export const ConcreteTestSet = new ConcreteTestSetPacketReportItem(
  '3B3A3626-33EC-4CAD-833B-BA606C0496EA'
)

export const ConcreteTestSetCylinders = new ConcreteTestSetReportItem({
  id: '29E3386C-EFEA-4FDD-AB6C-199B8C0302DD',
  name: 'Concrete Cylinder and IA Sheet by Concrete Test Set',
  queryParameter: 'cylinder-ia-sheet',
  sampleFilename: 'concrete-cylinder-and-ia-sheet',
  description: 'CONCRETE-STRENGTH-RPT',
  defaultTemplateItem: ConcreteFieldNumbers,
  additionalCompatibleTemplateItems: [ConcreteFieldNumbers, ConcreteTestSubIds],
})

export const ConcreteTestSetPlacements = new ConcreteTestSetReportItem({
  id: '0ABD65B6-5D78-4FA2-A30B-F5D01142C6AF',
  name: 'Concrete Placement and Core Sheet by Concrete Test Set',
  queryParameter: 'placement-core-sheet',
  sampleFilename: 'concrete-placement-and-core-sheet',
  description: 'THICKNESS',
  defaultTemplateItem: ConcretePlacementIds,
  additionalCompatibleTemplateItems: [ConcretePlacementIds],
})

export type ConcreteReportItem =
  | typeof ConcretePlacementCoreSheet
  | typeof ConcreteCylinderIASheet
  | typeof ConcreteTestSet
  | typeof ConcreteTestSetCylinders
  | typeof ConcreteTestSetPlacements
